import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { CloudDetailComponent } from '@serengeti/serengeti-resource';

@Component({
  selector: 'app-cloud-account-pool-create',
  templateUrl: './create.component.html',
  styleUrls: ['./create.component.scss']
})
export class ConsoleCloudAccountPoolCreateComponent implements OnInit {

	@ViewChild('createForm', {static: false}) createForm: CloudDetailComponent;

  constructor() { }

  ngOnInit() {
  }

  validateForm(messages): any {
    return this.createForm.validateForm(messages);
  }

}
